/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GUI                from 'g3w-app';
import { getUniqueDomId } from 'utils/getUniqueDomId';
import Input              from 'components/g3w-input';
import MediaField         from 'components/FieldMedia.vue';

const __vue_script__ = {

  /** @since 3.8.6 */
  name: 'input-media',

  mixins: [ Input ],
  components: {
    'g3w-media': MediaField
  },
  data() {
    return {
      data: {
        value:     null,
        mime_type: null
      },
      //@since 4.0.5 take in account allowed types from g3w-admin settings.py G3WFILE_FORM_UPLOAD_FORMATS
      accept: (this.state.input?.options?.allowed_types || []).map(a => `${a.startsWith('.') ? a : `.${a}`}` ).join(','),
      mediaid: `media_${getUniqueDomId()}`,
      loading: false
    }
  },
  methods: {
    onClick() {
      document.getElementById(this.mediaid).click();
    },
    clearMedia() {
      this.data.value = this.data.mime_type = this.state.value = null;
      this.change();
    },
    setMedia() {
      if (this.state.value) {
        this.data.value     = this.state.value.value;
        this.data.mime_type = this.state.value.mime_type;
      }
    },
    async onChangeFile(event) {
      const body = new FormData();
      body.append('csrfmiddlewaretoken', this.$cookie.get('csrftoken'));
      body.append(this.state.name, event.target.files[0]);

      this.loading = true;

      try {
        let response = (await (await fetch(this.state.input.options.uploadurl, {
          method:  'POST',
          headers: { Accept: 'application/json' },
          body
        })).json());
        //@since 4.0.5 in case 
        if (response?.result) {
          this.state.value = response?.data;
        }
        
        //@since 4.0.5
        if (false === response?.result) {
          GUI.showUserMessage({ type: 'alert', message: response.error || this.$t("server_error") });
        }
      } catch(e) {
        console.warn(e);
        GUI.notify.error(this.$t("server_error"));
      }

      this.loading = false;
    },
  },
  watch: {
    /**
     * @since 3.11.0
     */
    'state.value'() {
      this.setMedia();
      this.change();
    }
  },
  created() {
    this.setMedia();
  },
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baseinput',{attrs:{"state":_vm.state}},[_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.editable),expression:"!editable"}],attrs:{"slot":"body"},slot:"body"},[_c('div',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:top",value:(_vm.accept),expression:"accept",arg:"top"}],staticClass:"g3w_input_button skin-border-color",staticStyle:{"border-style":"solid","border-width":"2px","width":"100%","cursor":"pointer","text-align":"center"},on:{"click":_vm.onClick}},[_c('i',{staticClass:"fas fa-file-upload fa-2x skin-color",staticStyle:{"padding":"5px"}},[_c('input',{class:{'input-error-validation' : _vm.notvalid},staticStyle:{"display":"none"},attrs:{"id":_vm.mediaid,"name":_vm.state.name,"tabIndex":_vm.tabIndex,"data-url":_vm.state.input.options.uploadurl,"type":"file","accept":_vm.accept},on:{"change":_vm.onChangeFile}})])]),_vm._v(" "),_c('bar-loader',{attrs:{"loading":_vm.loading}}),_vm._v(" "),_c('g3w-media',{attrs:{"state":_vm.data}},[_c('div',{staticClass:"clearmedia",on:{"click":function($event){$event.stopPropagation();return _vm.clearMedia.apply(null, arguments)}}},[_c('i',{staticClass:"g3w-icon",class:_vm.g3wtemplate.font['trash-o']})])])],1)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "InputMedia.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__